import React, { useState,useEffect } from "react";
import { Link,useParams,useNavigate } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";

import { ChangeMobileFormat, unescapeHtml,PassedMonthsCode, addThousandPoint,isNull } from "../../components/common/Common";
import "../../css/style.css";

//청구서 발송
const InvoiceSending = () => {
  const { iv_idx } = useParams();
  const branch_idx = Number(localStorage.getItem('branch_idx'));
  const branch_member_id = localStorage.getItem('branch_member_id');
  const branch_merchant_id = localStorage.getItem('branch_merchant_id');
  const navigate = useNavigate();
  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  const [varInvoiceInfo,setInvoiceInfo] = useState({});
  const [varInvoiceChildrenList,setInvoiceChildrensList] = useState([]);

  //청구서 내역 호출
  const GetInvoiceInformation = async(childrenArray) => {
    const sendData = {branch_idx:branch_idx,iv_idx:iv_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_invoice_sending`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        //가맹점 로얄티
        const royaltys = datas.royaltys[0];
        //원생목록
        const childrens = datas.childrens;
        let newList = [];
        for(let i = 0; i < childrens.length; i++) {
          let ch_idx = childrens[i].ch_idx;

          //원생별 로얄티 저장
          let ty_price = 0;
          if(childrens[i].cl_type === 1) ty_price = royaltys.m_royalty;
          else ty_price = royaltys.f_royalty;
          childrens[i].ry_price = ty_price;

          if(childrenArray.includes(ch_idx)) {
            newList.push(childrens[i]);
          }
        }
        console.log(newList)
        setInvoiceChildrensList(newList);
        //청구서 정보
        setInvoiceInfo(datas.invoices[0]);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});

    let childrenArray = [];
    const childrenList = localStorage.getItem('selectChildrenList');
    if(!isNull(childrenList)) childrenArray = JSON.parse(childrenList);

    console.log(childrenArray);
    GetInvoiceInformation(childrenArray);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //청구서 발송
  const onSendingInvoiceHandler = async(e) => {
    if(!window.confirm('청구서를 발송하시겠습니까?')) return false;
    let invoiceList = [...varInvoiceChildrenList];
    for(var i = 0; i < invoiceList.length; i++) { 
      let invData = invoiceList[i];
      const sendData = {branch_member_id:branch_member_id,branch_merchant_id:branch_merchant_id,
                      bh_idx:varInvoiceInfo.bh_idx,cl_idx:varInvoiceInfo.cl_idx,ivInfo:varInvoiceInfo,invData:invData};
      console.log(sendData);
      let result = await axios.post(`${process.env.REACT_APP_HOST}/branch_sending_invoices`,sendData);
      console.log(result);
      if(i === invoiceList.length-1){
        console.log('end');
        alert('청구서를 발송하였습니다.');
        navigate('/Branch/InvoiceSet');
      }
    }
    console.log('finish');
  }

  return (
    <div className="vh-content">
      <HeaderBranchTitle varPageTitle={'청구서 발송 확인'}/>
      <div className="vh-content-body">
        <div className="payment-wrap">
          <div className="center-wrap">
            <div  className="send-con">
              <p className="tit">청구서 발송 대상 총 {varInvoiceChildrenList.length}명</p>
              {varInvoiceChildrenList.map((child,i)=>(
                <div key={'child_'+i} className="info-line">
                  <p>{child.mem_name} {ChangeMobileFormat(child.mem_mobile)} <span> 👼🏻[{child.ch_name}({PassedMonthsCode(child.ch_birthday)})]</span></p>
                </div>
              ))}
              <div className="txt-box">
                <div className="txt-line">
                  <p>학기</p>
                  <div>{varInvoiceInfo.sm_name}</div>
                </div>
                <div className="txt-line">
                  <p>클래스</p>
                  <div>{varInvoiceInfo.cl_name}</div>
                </div>
                <div className="txt-line">
                  <p>청구 금액</p>
                  <div>{addThousandPoint(varInvoiceInfo.iv_price)}원</div>
                </div>
                <div className="txt-line">
                  <p>청구 사유</p>
                  <div>{unescapeHtml(varInvoiceInfo.iv_reason)}</div>
                </div>
                <div className="txt-line">
                  <p>안내 메시지</p>
                  <div>{unescapeHtml(varInvoiceInfo.iv_message)}</div>
                </div>
              </div>
              <div className="attention-txt">
								<p>유의사항안내)</p>
								<div>청구서 발송 전 결제 선생을 통해 알림톡이 발송되며,<br/>반드시 잔여 발송톡 수량 조회 후 청구서를 발송해주세요.</div>
							</div>
            </div>
            <div className="form-contoller bt-btn">
							<Link to={'/Branch/InvoiceSet'} className="form-contoller-btn btn-no" style={{width:"48%"}}>취소</Link>
							<button type="button" className="form-contoller-btn btn-yes" onClick={e=>onSendingInvoiceHandler(e)}>청구서 발송</button>
						</div>
          </div>
        </div>
      </div>
    </div>	
  );
}
export default InvoiceSending;